module.exports = __webpack_public_path__ + "static/img/msg-box-info.ecc688c7.svg";